// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Notifications from '../components/Notifications';
import {actions as NotificationsActions} from '../duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    notifications: state.notifications.notifications,
    pagination: state.notifications.pagination,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...NotificationsActions,
      },
      dispatch
    )
)(Notifications);
